module.exports = __webpack_public_path__ + "be63d2bf78c882ff40cc57b0348c1038.svg";